var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.172,22.561A1,1,0,0,0,4,23H20a1,1,0,0,0,.929-1.372l-3.373-8.421A11.013,11.013,0,0,0,19,8V2a1,1,0,0,0-2,0V4.885a8.1,8.1,0,0,0-3-.44,2.882,2.882,0,0,0-2,1.2,2.882,2.882,0,0,0-2-1.2,8.1,8.1,0,0,0-3,.44V2A1,1,0,0,0,5,2V8a11.013,11.013,0,0,0,1.444,5.207L3.071,21.628A1,1,0,0,0,3.172,22.561Zm5.361-9.189A1,1,0,0,0,8.207,12.2C7.7,11.819,7,9.385,7,8c0-.91.215-1.555,2.92-1.566.28.111.97,1.077,1.577,1.43a1,1,0,0,0,1.006,0c.682-.4,1.155-1.166,1.5-1.419,2.785,0,3,.645,3,1.555,0,1.385-.7,3.819-1.207,4.2a1,1,0,0,0-.326,1.171L18.522,21H5.478Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress);
export default __webpack_public_path__ + "static/media/dress.309cc8c917879fe3329f564fa6103e7d.svg";
export { ForwardRef as ReactComponent };